module.exports = "https://static.wmbcdn.com/uniweb/images/06e5774f1463fc23fc472808887aa453.svg";